<template>
    <div>
        <GroupSubgroupSelector :operational="operational" :selectedPeriod="selectedPeriod" v-model="groupSelected" />
        <div class="text-center">
            <Button _key="btnTransfer" :disabled="!groupSelected.groupId" title="Alterar" color="white"
                backGroundColor="#2563EB" size="medium" :clicked="update" />
        </div>
    </div>
</template>
<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import GroupSubgroupSelector from './GroupSubgroupSelector.vue'

import { mapActions, mapMutations } from "vuex";

export default {
    name: "GroupSubgroupTransfer",
    props: ["rentId", "selected", "selectedPeriod", "item", "operational"],
    components: {
        Button, GroupSubgroupSelector
    },
    data() {
        return {
            urlUpdate: "/api/v1/rental/group-subgroup-rent/group-transfer",
            groupSelected: { groupId: "" },
        }
    },
    methods: {
        ...mapActions("generic", ["putApi"]),
        ...mapMutations("generic", ["addSelected", "addEvent", "removeLoading", "hideModal"]),
        update() {
            const payload = {
                url: this.urlUpdate,
                obj: {
                    listIds: this.selected.length > 0 ? this.selected : [this.item.id],
                    GroupId: this.groupSelected.groupId,
                },
                notNotifyToast: true
            };

            this.putApi(payload)
                .then((r) => {
                    if (r?.success) {
                        this.addEvent({ name: "updateTotalizationRent" });
                        this.hideModal();
                    }
                    this.addSelected([]);
                    this.removeLoading(["btnTransfer"]);
                })
                .catch(() => {
                    this.removeLoading(["btnTransfer"]);
                });
        }
    },
}

</script>